/**
 * Fields of many lines grow with what is written in them, typed or dictated (D-251): never
 * scrolled inside a page that already scrolls. Browsers that size a field by its content
 * (`field-sizing: content`, index.css) do it themselves; for the others, a field is sized as it is
 * typed in, entered, or changed by dictation (`grow`).
 */
const native = () => typeof CSS !== 'undefined' && CSS.supports?.('field-sizing', 'content')

export function grow(el) {
  if (native() || !(el instanceof HTMLTextAreaElement)) return
  el.style.height = 'auto'
  el.style.height = `${el.scrollHeight + el.offsetHeight - el.clientHeight}px`
}

export function installAutogrow(doc = document) {
  if (native()) return
  const onEvent = (e) => grow(e.target)
  doc.addEventListener('input', onEvent, true)
  doc.addEventListener('focusin', onEvent, true)
}
